// appConfirm.js
import { confirmDialog } from "primereact/confirmdialog";

const metaByGroup = new Map();

export function getAppConfirmMeta(group) {
  return metaByGroup.get(group) || {};
}

export function clearAppConfirmMeta(group) {
  metaByGroup.delete(group);
}

// Use this everywhere instead of confirmDialog(...)
export function appConfirm({
  group = "appConfirm",
  scheme = "neutral",
  icon = "bi bi-exclamation-triangle",
  acceptLabel = "Confirm",
  rejectLabel = "Cancel",
  acceptClassName,
  rejectClassName,
  accept,
  reject,
  ...opts
}) {
  metaByGroup.set(group, {
    scheme,
    icon,
    acceptLabel,
    rejectLabel,
    acceptClassName,
    rejectClassName,
    onAccept: accept,
    onReject: reject,
  });

  confirmDialog({
    group,
    accept,
    reject,
    ...opts,
    // clean up when dialog closes (accept/reject/outside click/esc)
    onHide: () => {
      setTimeout(() => clearAppConfirmMeta(group), 250);
      // clearAppConfirmMeta(group);
    },
  });
}
